mutation CloseContentPoll($id: ID!) {
  closeContentPoll(id: $id) {
    id
    status
    closedAt
  }
}
